import { createActions, createReducer } from 'reduxsauce'

import ConsultaListaIndicadoresService from '../../servicos/ConsultaListaIndicadoresService'
/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaListaIndicadoresPlanejamentoEstrategicoInicio: [],
    buscaConsultaListaIndicadoresPlanejamentoEstrategicoErro: ['erro'],
    buscaConsultaListaIndicadoresPlanejamentoEstrategicoSucesso: ['consultaListaIndicadoresPlanejamentoEstrategico'],
    limpar: [],
    setConsultaListaIndicadoresPlanejamentoEstrategicoEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaListaIndicadoresPlanejamentoEstrategico = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaListaIndicadoresPlanejamentoEstrategicoInicio())
        let serv = new ConsultaListaIndicadoresService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaListaIndicadoresPlanejamentoEstrategicoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaListaIndicadoresPlanejamentoEstrategicoErro(error)))
    }
}

const buscaConsultaListaIndicadoresPlanejamentoEstrategicoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaListaIndicadoresPlanejamentoEstrategicoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaListaIndicadoresPlanejamentoEstrategicoSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaListaIndicadoresPlanejamentoEstrategico.resultado,
        dataSincronizacaoDados: action.consultaListaIndicadoresPlanejamentoEstrategico.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaListaIndicadoresPlanejamentoEstrategicoEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO_INICIO]: buscaConsultaListaIndicadoresPlanejamentoEstrategicoInicio,
    [Types.BUSCA_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO_ERRO]: buscaConsultaListaIndicadoresPlanejamentoEstrategicoErro,
    [Types.BUSCA_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO_SUCESSO]: buscaConsultaListaIndicadoresPlanejamentoEstrategicoSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO_ESTADO_DT]: setConsultaListaIndicadoresPlanejamentoEstrategicoEstadoDT,
})
